import { Grid, IconButton, Table, TableBody, TableCell, TableRow
    , Typography, Box } from '@mui/material'
import { AddCircle as IconAddCircle, Delete as IconDelete } from "@mui/icons-material";
import api from "../services/api";
import * as evaluacionService from "../services/evaluacionService";
import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { setEntity, setData, add, remove
    , setValidations
} from '../redux/therapyPlanObjetivoSlice'
import AutocompleteRegistro from './AutocompleteRegistro'
import DialogYesNo from './DialogYesNo'

// El detalle de objetivos del plan de terapia.
//
// Cada fila dice que objetivo del catalogo de objetivos de temas de evaluacion
// (objetivocatalogo) se sigue en el plan: el detalle queda en plan + objetivo +
// orden, y el area no interviene. Es el detalle del que sale el reporte anual.
//
// El listado del catalogo se carga una vez para el autocompletado; con tres
// letras o mas la busqueda va al servidor. Los objetivos se dan de alta en su
// propio mantenimiento (Objetivos), asi que aqui no se registran.
const TherapyPlanObjetivo = (props) => {
    const isReadOnly = props.isReadOnly;
    const params = useParams();
    const entity = useSelector((state) => state.therapyPlanObjetivo.entity);
    const validate = useSelector((state) => state.therapyPlanObjetivo.validationActive);

    // El catalogo de objetivos de temas de evaluacion, en una sola lista para
    // todas las filas del detalle.
    const [objetivos, setObjetivos] = useState([]);
    const [openDialogDelete, setOpenDialogDelete] = useState(false)
    const openCloseDialogDelete = () => { setOpenDialogDelete(!openDialogDelete); }
    const [selectNumero, setSelectNumero] = useState(null);
    const dispatch = useDispatch();

    const setItemValue = (numero, name, value) => {
        dispatch(setData({numero: numero, name: name, value: value}))
    }

    const fecthEntity = useCallback(async () => {
        if (!params.id || params.id == "0") {
            dispatch(setEntity([]));
            return;
        }

        const response = await api.get("/TerapiaPlan/GetsTerapiaPlanObjetivoView?idTerapiaPlan=" + params.id)
            .then((response) => {
                if (response.data.data == null || response.data.data.length == 0) {
                    dispatch(setEntity([]));
                }
                else {
                    dispatch(setEntity(response.data.data));
                }
            })
            .catch((err) => {
                console.log("Err: ", err)
            });
    }, [params.id, dispatch])

    // Las opciones del autocompletado: el catalogo completo, ordenado por tema
    // y nombre (el endpoint ya lo trae asi).
    const fetchObjetivos = useCallback(async () => {
        const data = await evaluacionService.getsObjetivoCatalogoView(0)
            .catch((err) => { console.log("Err: ", err); return []; });

        setObjetivos(data || []);
    }, [])

    // Busca objetivos del catalogo en el servidor (autocompletado del Objetivo).
    const buscarObjetivo = useCallback(async (texto) => {
        const data = await evaluacionService.buscarObjetivoCatalogo(texto)
            .catch((err) => { console.log("Err: ", err); return []; });
        return data || [];
    }, [])

    const messagesValidation = useCallback(() => {
        const messages = [];
        // No es obligatorio tener objetivos. Si el usuario agregó filas, solo se valida que tengan un objetivo seleccionado.
        for (const row of (entity || [])) {
            if (!(row.idObjetivoCatalogo > 0)) {
                messages.push("Indique el objetivo");
                break;
            }
        }
        return messages;
    }, [entity]);

    const deleteItem = useCallback(async () => {
        if (params.id && params.id != "0") {
            await api.delete("/TerapiaPlan/DeleteTerapiaPlanObjetivo?idTerapiaPlan="
                + params.id + "&numero=" + selectNumero)
                .catch((err) => {
                    console.log("Err: ", err);
                });
        }
        dispatch(remove(selectNumero));
        openCloseDialogDelete();
    }, [params.id, selectNumero, dispatch]);

    useEffect(() => {
        fecthEntity();
        fetchObjetivos();
    }, [fecthEntity, fetchObjetivos]);

    useEffect(() => {
        dispatch(setValidations(messagesValidation()));
    }, [dispatch, messagesValidation]);

    return (
        <Grid container>
            <Grid item>
                <Typography variant="h7">
                    <Box sx={{ fontWeight: 'bold' }} padding={0}>
                        {"Objetivos del plan (" + (entity != null ? entity.length : 0) + ")"}
                    </Box>
                </Typography>
            </Grid>
            <Grid item>
                <IconButton disabled={isReadOnly} size="small" aria-label="Agregar Objetivo" style={{height: 10}} onClick={() => {
                    dispatch(add(params.id));
                }}>
                    <IconAddCircle />
                </IconButton>
            </Grid>
            <Grid container>
                <Table size="small">
                    <TableBody>
                        {(entity || []).map((row) => (
                            <TableRow key={row.numero}>
                                <TableCell>
                                    <AutocompleteRegistro
                                        label="Objetivo"
                                        name="idObjetivoCatalogo"
                                        disabled={isReadOnly}
                                        texto={row.objetivo}
                                        idSeleccionado={row.idObjetivoCatalogo}
                                        opciones={objetivos || []}
                                        getLabel={(opcion) => opcion.nombre || opcion.descripcion}
                                        onTexto={(t) => setItemValue(row.numero, "objetivo", t)}
                                        onSeleccionar={(objetivo) => {
                                            const id = (objetivo != null && objetivo.id > 0) ? objetivo.id : null;
                                            setItemValue(row.numero, "idObjetivoCatalogo", id);
                                            setItemValue(row.numero, "objetivo", objetivo != null ? (objetivo.nombre || "") : "");
                                            setItemValue(row.numero, "descripcion", objetivo != null ? (objetivo.descripcion || "") : "");
                                        }}
                                        onBuscar={(texto) => buscarObjetivo(texto)}
                                        puedeRegistrar={false}
                                        tipoRegistro="objetivo"
                                    />
                                </TableCell>
                                <TableCell>
                                    <IconButton disabled={isReadOnly} size="small" aria-label="Eliminar Objetivo" onClick={() => {
                                        setSelectNumero(row.numero);
                                        openCloseDialogDelete();
                                    }}>
                                        <IconDelete />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Grid>
            <DialogYesNo
                open={openDialogDelete}
                onConfirm={deleteItem}
                onClose={openCloseDialogDelete}
                titulo="Eliminar"
                texto="¿Confirma eliminar el objetivo?"
            />
        </Grid>
    );
}
export default TherapyPlanObjetivo;
